<template functional>
  <div class="payment-methods">
    <div class="title">Способы оплаты заказа</div>
    <div class="methods">
      <div>
        <svg-inline :src="require('@/assets/icons/payment1.svg')" />
        <div class="method-title">Наличными<br/>курьеру</div>
      </div>
      <div>
        <svg-inline :src="require('@/assets/icons/payment2.svg')" />
        <div class="method-title">По карте<br/>курьеру</div>
      </div>
      <!-- <div>
        <svg-inline :src="require('@/assets/icons/payment3.svg')" />
        <div class="method-title">Переводом с карты на карту<br/><span class="number">4817 7602 8484 7922</span></div>
      </div> -->
    </div>
    <div class="details">Время доставки заказа: от 1 часа<br />*Время доставки может изменяться в связи с дорожной ситуацией</div>
  </div>
</template>

<script>
  export default {
    name: 'PaymentMethods'
  }
</script>



// WEBPACK FOOTER //
// src/blocks/PaymentMethods.vue